/* eslint-disable */
import React, { useEffect, useState } from "react";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { useFormContext } from '@/providers';
import { TextEditor } from "../Editor";
import CancellationPolicies from "./Policies/CancellationPolicies ";
import { axiosInstanceWithToken } from "@/helpers/axios";
import RulesSelection from "./RulesSelection";
import WelcomeMessageInstructions from "./WelcomeMessage";
const times = [
    "06:00 AM", "06:30 AM", "07:00 AM", "07:30 AM", "08:00 AM", "08:30 AM",
    "09:00 AM", "09:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM",
    "12:00 PM", "12:30 PM", "01:00 PM", "01:30 PM", "02:00 PM", "02:30 PM",
    "03:00 PM", "03:30 PM", "04:00 PM", "04:30 PM", "05:00 PM", "05:30 PM",
    "06:00 PM", "06:30 PM", "07:00 PM", "07:30 PM", "08:00 PM", "08:30 PM",
    "09:00 PM"
];

export const CancellationPolicy = () => {
    const { errors, handleChange, watch, setValue, fieldRefs } = useFormContext();

    const [cancellation_policy, setCancellationPolicy] = useState([""]);

    const GetData = () => {
        axiosInstanceWithToken
            .get(`/cancellation-policy`)
            .then((res) => {
                setCancellationPolicy(res.data?.data || []);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        GetData();
    }, []);

    const handleRangeChange = (type, value) => {
        if (type === 'infant') {
            // setValue('infant_ages',
            //     {
            setValue('infant_start_age', value[0]);
            setValue('infant_end_age', value[1])

            //     }
            // )
        } else {
            setValue('child_start_age', value[0]);
            setValue('child_end_age', value[1])
        }

    }

    // Handle selection change
    // const handleSelectChange = (event) => {
    //     const selectedPolicy = event.target.value;
    //     // Update only the 'cancellation_policy' field while preserving the rest of the form data
    //     setValue('cancellation_policy', selectedPolicy);
    // };

    return (
        <div className="gap-2 text-left md:col-span-12">
            <div className="text-left md:col-span-12" ref={(el) => (fieldRefs.current[`cancellation_policy_short`] = el)}>
                <label>
                    Cancellation Policies Short (Please choose one)
                    <i className="fal fa-clock ms-1" />
                </label>
                <CancellationPolicies field={'cancellation_policy_short'} />
            </div>

            <div className="text-left md:col-span-12" ref={(el) => (fieldRefs.current[`cancellation_policy_long`] = el)}>
                <label>
                    Cancellation Policies Long (Please choose one, if you are stays that are greater than 28 days.)
                    <i className="fal fa-clock ms-1" />
                </label>
                <CancellationPolicies field={'cancellation_policy_long'} />
            </div>
            {/* <div className="mt-3 text-left md:col-span-12">
                <label>
                    Long Cancellation Policy
                    <i className="fal fa-times-circle" />
                </label>
                <select
                    data-placeholder="cancellation_policy_long"
                    className={`border border-input px-3 py-3 rounded-md gap-4 items-center w-full `}
                    name="cancellation_policy_long"
                    value={watch('cancellation_policy_long') || ""}
                    onChange={handleChange}
                >
                    <option disabled value="">
                        Select
                    </option>
                    {cancellation_policy?.map((item, index) => (
                        <option key={index} value={item.id}>
                            {item.name}
                        </option>
                    ))}
                </select>
                {errors.cancellation_policy_long && (
                    <span style={{ color: "red" }}>{errors.cancellation_policy_long.message}</span>
                )}
            </div> */}


            {/* ---------------------------------------------------------------------- */}

            <div className="grid grid-cols-1 gap-4 mt-2 md:grid-cols-2">
                <div className="text-left">
                    <label>Minimum Days of a Booking</label>
                    <div className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input">
                        <i className="fal fa-calendar-minus" />
                        <input
                            type="number"
                            name="min_day_booking"
                            ref={(el) => (fieldRefs.current[`min_day_booking`] = el)}
                            value={watch('min_day_booking')}
                            onChange={handleChange}
                            placeholder="Minimum Days of a Booking"
                        />
                    </div>
                    {errors.min_day_booking && (
                        <span style={{ color: "red" }}>
                            {errors.min_day_booking.message}
                        </span>
                    )}
                </div>

                <div className="text-left">
                    <label>Maximum Days of a Booking</label>
                    <div className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input">
                        <i className="fal fa-calendar-plus" />
                        <input
                            name="max_day_booking"
                            value={watch('max_day_booking')}
                            ref={(el) => (fieldRefs.current[`max_day_booking`] = el)}
                            onChange={handleChange}
                            type="number"
                            placeholder="Maximum Days of a Booking"
                        />
                    </div>
                    {errors.max_day_booking && (
                        <span style={{ color: "red" }}>
                            {errors.max_day_booking.message}
                        </span>
                    )}
                </div>
            </div>



            <div className="grid grid-cols-1 gap-4 mt-2 md:grid-cols-2">
                <div className="text-left">
                    <label>
                        Check In After
                        <i className="fal fa-clock" />
                    </label>
                    <select
                        value={watch('check_in_after')}
                        name="check_in_after"
                        ref={(el) => (fieldRefs.current[`check_in_after`] = el)}
                        onChange={handleChange}
                        data-placeholder="Apartments"
                        className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                    >
                        <option>Select</option>
                        {times.map((time, index) => (
                            <option key={index} value={time}>
                                {time}
                            </option>
                        ))}
                    </select>
                    {errors?.check_in_after && (
                        <p style={{ color: "red" }}>
                            {errors?.check_in_after?.message}
                        </p>
                    )}
                </div>

                <div className="text-left">
                    <label>
                        Check Out Before
                        <i className="fal fa-clock" />
                    </label>
                    <select
                        value={watch('check_out_before')}
                        name="check_out_before"
                        ref={(el) => (fieldRefs.current[`check_out_before`] = el)}
                        onChange={handleChange}
                        data-placeholder="Apartments"
                        className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                    >
                        <option>Select</option>
                        {times.map((time, index) => (
                            <option key={index} value={time}>
                                {time}
                            </option>
                        ))}
                    </select>
                    {errors?.check_in_after && (
                        <p style={{ color: "red" }}>
                            {errors?.check_in_after?.message}
                        </p>
                    )}
                </div>
            </div>


            <div className="grid grid-cols-1 gap-4 mt-2 md:grid-cols-2">
                <div className="text-left">
                    <label>
                        Smoking Allowed
                        <i className="fal fa-clock" />
                    </label>
                    <div className="listsearch-input-item">
                        <select
                            value={watch('smoking_allowed') || 0}
                            name="smoking_allowed"
                            ref={(el) => (fieldRefs.current[`smoking_allowed`] = el)}
                            onChange={handleChange}
                            data-placeholder="smoking_allowed"
                            className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full `}
                        >
                            <option disabled value={""}>
                                Select
                            </option>
                            <option value={1}>Yes</option>
                            <option value={0}>No</option>
                        </select>
                        {errors.smoking_allowed && (
                            <span style={{ color: "red" }}>
                                {errors.smoking_allowed.message}
                            </span>
                        )}
                    </div>
                </div>
                <div className="text-left">
                    {+watch('smoking_allowed') === 1 ? (
                        <>
                            <label>Write your conditions here.</label>
                            <div className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input">
                                <i className="fal fa-briefcase" />
                                <input
                                    type="text"
                                    name="smoking_rules"
                                    ref={(el) => (fieldRefs.current[`smoking_rules`] = el)}
                                    defaultValue={watch('smoking_rules') || ""}
                                    placeholder="Write your conditions here."
                                    onChange={handleChange}
                                />
                            </div>
                        </>
                    ) : <></>}
                </div>
            </div>

            <div className="grid grid-cols-1 gap-4 mt-2 md:grid-cols-2">
                <div className="text-left">
                    <label>
                        Pets Allowed
                        <i className="fal fa-clock" />
                    </label>
                    <select
                        value={watch('rules_pet_allowed') || 0}
                        name="rules_pet_allowed"
                        ref={(el) => (fieldRefs.current[`rules_pet_allowed`] = el)}
                        onChange={handleChange}
                        data-placeholder="rules_pet_allowed"
                        className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full `}
                    >
                        <option disabled value={""}>
                            Select
                        </option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                    </select>
                    {errors.rules_pet_allowed && (
                        <span style={{ color: "red" }}>{errors.rules_pet_allowed.message}</span>
                    )}
                </div>
                <div className="text-left">
                    {+watch('rules_pet_allowed') === 1 ? (
                        <>
                            <label>Write your conditions here.</label>
                            <div className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input">
                                <i className="fal fa-briefcase" />
                                <input
                                    type="text"
                                    placeholder="Write your conditions here."
                                    ref={(el) => (fieldRefs.current[`pet_rules`] = el)}
                                    name="pet_rules"
                                    defaultValue={watch('pet_rules') || ''}
                                    onChange={handleChange}
                                />
                            </div>
                        </>
                    ) : <></>}
                </div>
            </div>


            <div className="grid grid-cols-1 gap-4 mt-2 md:grid-cols-2">
                <div className="text-left">
                    <label>
                        Parties Allowed
                        <i className="fal fa-clock" />
                    </label>
                    <select
                        value={watch('party_allowed') || 0}
                        name="party_allowed"
                        onChange={handleChange}
                        data-placeholder="party_allowed"
                        ref={(el) => (fieldRefs.current[`party_allowed`] = el)}
                        className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full `}
                    >
                        <option disabled value={""}>
                            Select
                        </option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                    </select>
                    {errors.party_allowed && (
                        <span style={{ color: "red" }}>{errors.party_allowed?.message}</span>
                    )}
                </div>
                <div className="text-left">
                    {+watch('party_allowed') === 1 ? (
                        <>
                            <label>Write your conditions here.</label>
                            <div className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input">
                                <i className="fal fa-briefcase" />
                                <input
                                    type="text"
                                    placeholder="Write your conditions here."
                                    name="party_rules"
                                    ref={(el) => (fieldRefs.current[`party_rules`] = el)}
                                    defaultValue={watch('party_rules') || ''}
                                    onChange={handleChange}
                                />
                            </div>
                        </>
                    ) : <></>}
                </div>
            </div>

            <div className="grid grid-cols-1 gap-4 mt-2 md:grid-cols-2">
                <div className="text-left">
                    <label>
                        Children Allowed
                        <i className="fal fa-clock" />
                    </label>
                    <select
                        value={watch('children_allowed') || 0}
                        name="children_allowed"
                        ref={(el) => (fieldRefs.current[`children_allowed`] = el)}
                        onChange={handleChange}
                        data-placeholder="Apartments"
                        // className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full ${errors.children_allowed ? "error" : ""
                        //     }`}
                        className={`flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full`}
                    >
                        <option disabled value={""}>
                            Select
                        </option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                    </select>
                    {errors.children_allowed && (
                        <span style={{ color: "red" }}>
                            {errors.children_allowed.message}
                        </span>
                    )}
                </div>
                <div className="text-left">
                    {+watch('children_allowed') === 1 ? (
                        <>
                            <label>Write your conditions here.</label>
                            <div className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input">
                                <i className="fal fa-briefcase" />
                                <input
                                    type="text"
                                    placeholder="Write your conditions here."
                                    name="children_rules"
                                    ref={(el) => (fieldRefs.current[`children_rules`] = el)}
                                    defaultValue={watch('children_rules') || ""}
                                    onChange={handleChange}
                                />
                            </div>
                        </>
                    ) : <></>}
                </div>
            </div>

            {
                +watch('children_allowed') === 1 ? (
                    <>
                        <div className="text-left md:col-span-12">
                            <label>
                                Infants ages:{watch('infant_start_age') || 0} - {watch('infant_end_age') || 24} months
                            </label>
                            <div className="pt-5">
                                <RangeSlider
                                    min={0}
                                    max={24}
                                    name={'infant_min_age'}
                                    defaultValue={[+watch('infant_start_age') || 0, +watch('infant_end_age') || 24]}
                                    onInput={(e) => handleRangeChange('infant', e)}
                                />
                            </div>
                        </div>

                        <div className="text-left md:col-span-12">
                            <label>
                                Children ages: {+watch('child_start_age') || 2} - {+watch('child_end_age') || 17} years
                            </label>
                            <div className="pt-5">
                                <RangeSlider
                                    min={2}
                                    max={17}
                                    name={'infant_max_age'}
                                    defaultValue={[+watch('child_start_age') || 2, +watch('child_end_age') || 17]}
                                    onInput={(e) => handleRangeChange('children', e)}
                                />
                            </div>
                        </div>
                    </>
                ) : null
            }

            <RulesSelection />

            <WelcomeMessageInstructions />
        </div>
    );
};
